/* @flow */
// typecheck: ignore file
import Glyph from 'components/Glyph.jsx';
import Group from 'entities/Group';
import ModalMenuItem from 'components/ModalMenuItem.jsx';
import React from 'react';
import RequestTranscriptModal from 'organizations/components/RequestTranscriptModal.jsx';
import GroupMembership from 'entities/GroupMembership';

type Props = {
  isAdminView?: bool,
  groupToAdmin: Group,
  groupMembership: GroupMembership,
}

class GetTranscriptMenuItem extends React.Component {
  props: Props;

  requestTranscriptModal = () => {
    const { groupMembership, groupToAdmin, isAdminView } = this.props;
    const org = groupToAdmin.getOrganization();

    const users = [{
      id: groupMembership.getUserId(),
      fullName: groupMembership.getUser().getFullName(),
      firstName: groupMembership.getUser().getFirstName(),
      canGetMessageHistory: groupMembership.hasPermission('can_get_message_history'),
      canRequestMessageHistory: groupMembership.hasPermission('can_request_message_history'),
    }];

    return (
      <RequestTranscriptModal
        users={users}
        organizationId={org.id}
        organizationName={org.getName()}
        forceRequestMessageHistory={!isAdminView}
      />
    );
  };

  render() {
    return (
      <ModalMenuItem modal={this.requestTranscriptModal()}>
        <Glyph name="email-transcript" />
        <span>
          {this.props.isAdminView ? 'Get message history' : 'Request message history'}
        </span>
      </ModalMenuItem>
    );
  }
}

export default GetTranscriptMenuItem;



// WEBPACK FOOTER //
// ./src/user/components/GetTranscriptMenuItem.jsx